<template>
	<div
		:class="clsx(
			className,
			'mt-6 flex flex-col-reverse items-center justify-end gap-3 *:w-full sm:mt-4 sm:flex-row sm:*:w-auto')">
		<slot />
	</div>
</template>

<script setup lang="ts">
	import {
		clsx,
	} from "clsx"

	const props = defineProps({
		className: {
			type: String,
			default: "",
		},
	})
</script>